import type { DisconnectAccountingOAuthRequest } from "@src/domain/dto/accountingOAuth";
import type { IAccountingOAuthRepository } from "@src/domain/repositories/accountingOAuth";

export class DisconnectAccountingOAuthUseCase {
  private readonly repository: IAccountingOAuthRepository;

  constructor(repository: IAccountingOAuthRepository) {
    this.repository = repository;
  }

  execute(params: DisconnectAccountingOAuthRequest): Promise<void> {
    return this.repository.disconnect(params);
  }
}
